module.exports = __webpack_public_path__ + "img/19.a819ded8.jpg";